<template>
    <div class="modal fade" id="updateUserModal" role="dialog" aria-labelledby="updateUserModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updateUserModalLabel">{{$t('aspNetUser.edit')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <user-edit-card v-model="model"
                                    v-if="showEditor"
                                    :create="false"
                                    @save="onSave"
                                    @cancel="onCancel">
                    </user-edit-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { AspNetUser } from '@/models/models';
    import UserEditCard from './UserEditCard';

    export default {
        components: {
            UserEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showEditor: false,
                model: new AspNetUser(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new AspNetUser();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave() {
                this.$emit('onSave');
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new AspNetUser(this.value);
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
